import { render, staticRenderFns } from "./OnboardingAdministrativeInfoPage.vue?vue&type=template&id=c4f010c6&scoped=true&"
import script from "./OnboardingAdministrativeInfoPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingAdministrativeInfoPage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingAdministrativeInfoPage.vue?vue&type=style&index=0&id=c4f010c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f010c6",
  null
  
)

export default component.exports